module.exports = __webpack_public_path__ + "80b6210a0c9cce786bed8239421e36de.png";